import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/quadratic-equation-calculator',
  component: () => import('../../routes/QuadraticEquationCalculator.svelte'),
  card: {
    id: 'quadratic-equation-calculator',
    title: 'Quadratic Equation Calculator',
    description: 'Solve any quadratic equation ax² + bx + c = 0. Find real and complex roots, vertex, axis of symmetry, and factored form instantly.',
    icon: 'calculate',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/quadratic-equation-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Quadratic Equation Calculator – Solve ax² + bx + c = 0 Free',
    description: 'Free quadratic equation calculator to solve any ax² + bx + c = 0. Find real and complex roots, vertex, axis of symmetry, and factored form with step-by-step results.',
  },
};

export default meta;
